import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HeaderTemplateData } from '../dialog-data.interface';

interface ConfirmationHeaderAndDialogData {
  header: HeaderTemplateData;
  dialogData: ConfirmationDialogData;
}

export interface ConfirmationDialogData {
  title: string;
  content: string;
  textBox: TextBox;
  no: string;
  yes: string;
}

export interface TextBox {
  isTextBoxRequired: boolean;
  isShow: boolean;
  label?: string;
}

@Component({
  selector: 'confirmation-dialog',
  templateUrl: 'confirmation-dialog.html',
})
export class ConfirmationDialog implements OnInit {
  header:HeaderTemplateData
  remarkForm: FormGroup;
  // resultDefault = { title: "Delete Confirmation", content: "Delete selected item will not be recoverd.", yes: "Ok", no: "Cancel", showTextBox: false };
  // result = this.resultDefault;
  result:ConfirmationDialogData;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialog>,
    @Inject(MAT_DIALOG_DATA) private data: ConfirmationHeaderAndDialogData) {

    if (data) {
      this.header = data.header;
      this.result = data.dialogData;
    }

  }

  ngOnInit() {
    if(this.result.textBox.isShow){
      if(this.result.textBox.isTextBoxRequired){
        this.remarkForm = new FormGroup(
          {
            remark: new FormControl('', [Validators.required])
          }
        );
      }else{
        this.remarkForm = new FormGroup(
          {
            remark: new FormControl('')
          }
        );
      }
    
    }
   
  }



  onSubmit(){
    if(this.result.textBox.isShow){
      if(this.remarkForm.valid){
        this.dialogRef.close(this.remarkForm.value);
      }
    }else{
      this.dialogRef.close(true);
    }
   
  }



}